import { Box } from '@mui/material'
import React from 'react'
import SearchBar from './SearchBar'
import Add from './Add'
import Title from '../components/Title'
import Liste from './Liste'

export default function MajSpider() {
    return (
        <Box sx={{ flexGrow: 1, width: "100%" }}>

            <Box style={{ display: "flex", justifyContent: "space-between" }} >
                {/*---------------- debut titre --------------*/}
                <Title
                    intitule='Mise à jour spider'
                />
                {/*---------------- fin titre --------------*/}

                {/*---------------- debut add --------------*/}
                <Box sx={{ width: "50%" }}>
                    <SearchBar />
                </Box>
                {/*---------------- fin add --------------*/}


                {/*---------------debut SearchBar --------- */}
                <Box>
                    <Add />
                </Box>
                {/* ------------------fin  SearchBar ------------*/}
            </Box>

            {/*---------------- debut Liste -----------------*/}
            <Liste />
            {/*--------------- fin Liste ------------------ */}
        </Box>
    )
}
